module.exports = __webpack_public_path__ + "static/media/icon_1.c6dc8cf6.png";